import Layout from '@components/Items/Filters/Layout'
import useFilter from '@components/Items/utils/hooks/useFilter'
import { FC } from 'react'
import _isArray from 'lodash/isArray'
import Checkbox from '@components/Items/components/checkbox'
import { NUMBER_OF_UNIQUE_BIDDERS_LIST } from '@components/Items/utils/constants'
import { QUERY_KEYS } from '@components/Items/utils/functions'

const NumberOfUniqueBidders = () => {

  return (
    <Layout label={'NUMBER OF UNIQUE BIDDERS'}>
      <fieldset>
        <legend className="sr-only">Number of Unique Bidders</legend>
        <div className="space-y-1">
          {NUMBER_OF_UNIQUE_BIDDERS_LIST.map((numberOfBidders) => (
            <NumberOfUniqueBiddersItem
              numberOfBidders={numberOfBidders}
              key={`number-of-bidders-${numberOfBidders}`}
            />
          ))}
        </div>
      </fieldset>
    </Layout>
  )
}

const NumberOfUniqueBiddersItem: FC<{ numberOfBidders: string }> = ({ numberOfBidders }) => {
  const { updateQuery, numberOfUniqueBiddersQuery } = useFilter()

  const handleChange = async () => {
    await updateQuery(QUERY_KEYS.NUMBER_OF_UNIQUE_BIDDERS, numberOfBidders, false)
  }

  const isChecked = numberOfUniqueBiddersQuery
    ? _isArray(numberOfUniqueBiddersQuery)
      ? numberOfUniqueBiddersQuery.includes(numberOfBidders)
      : numberOfUniqueBiddersQuery === numberOfBidders
    : false

  return (
    <Checkbox checked={isChecked} onChange={handleChange}>
      {numberOfBidders}
    </Checkbox>
  )
}

export default NumberOfUniqueBidders
